import React, { Component } from 'react';
import HalfScreenTextParent from './HalfScreenTextParent';
import CenteredTextTest from './CenteredTextTest';
import Fade from 'react-reveal/Fade';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import FlexCenter from './FlexCenter';
import rightarrow from './rightarrow.png';
import { Link } from 'react-router-dom';

class GoToGallery extends Component {
  constructor(){
    super()
    this.state = {
      flag: false
    }
  }
  render(){
    var contentObj = furnishedLivingObj
    if(this.props.content === "gallery"){
      contentObj = galleryObj
    }

    return (
      <div className="furnished-living-frame">
        <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
        <div style={{height: '100%', padding: '2em 0em'}} className="col-lg-8 col-md-10 col-sm-10 col-xs-10">
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
          <FlexCenter width={'100%'}>
            <div>
              <Fade top>
                <h1 className="ourStandardH1">{contentObj.title}</h1>
              </Fade>
              <Fade bottom>
                <div className="furnishedLivingBodyText">{contentObj.text1}</div>
                <div className="furnishedLivingBodyText">{contentObj.text2}</div>
              </Fade>
              <Fade bottom>
                  <div className="flex-container furnishedLivingBtnContainer">
                    <Link style={{textDecoration: 'none'}} to={"/gallery"}>
                      <div className="furnishedLivingBtn" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                          <p>{contentObj.buttonText}</p>
                          <div className='fp-arrows-container' style={{width: '40px', overflow: 'hidden', display: 'flex'}}>
                            <div className="fp-left-arrow"><img style={{width: '17px'}} src={rightarrow} alt="Button"/></div>
                            <div className="fp-right-arrow" style={{marginLeft: '35px'}}><img style={{width: '17px'}} src={rightarrow} alt="Button"/></div>
                          </div>
                      </div>
                    </Link>
                  </div>
              </Fade>
            </div>
          </FlexCenter>
        </div>
        </div>
        <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
      </div>
    )
  }
}

export default GoToGallery;


var furnishedLivingObj = {
  title: 'Furnished Living',
  text1: 'Our luxury furnished apartments are situated in the finest locations of West Hollywood and Santa Monica. We offer long-term rentals (31 days minimum) in our studio, one-bedroom, and two-bedroom apartments. Each unit is finished with fine appliances and detailed decorations. We balance style and comfort to provide a home away from home.' ,
  text2: 'Our properties are situated in the best parts of West Hollywood and Santa Monica. In West Hollywood we are short walk to Robertson and 3rd. In Santa Monica, you can find us on Montana Ave, just steps to the beach.',
  buttonText: 'Explore Floor Plans'
}

var galleryObj = {
  title: 'Luxury & Comfort',
  text1: 'Explore our gallery to see the quality of our furnished apartments. They come with complete kitchens, utilities, parking, central a/c, flat-screen TVs, full-cable, Netflix/Apple TV, and marble/tile bathroom floors. All of our units come with parking for one or two and we are pet friendly upon approval.' ,
  text2: '',
  buttonText: 'Explore Gallery'
}



// WEBPACK FOOTER //
// ./src/GoToGallery.js